import { UseCaseFormData } from "./UseCaseContributePage";

/**
 * Builds the Catalogical payload from form data.
 * Shared between UseCaseContributePage (draft save) and ReviewAndSubmitStep (publish).
 */
export function buildUseCasePayload(
  formData: UseCaseFormData,
  status: "DRAFT" | "PUBLISHED",
  contributorAlias: string,
  contributorFullName: string
): Record<string, any> {
  return {
    dataDomain: "aiforme",
    name: formData.title || "Untitled Draft",
    shortDescription: formData.shortDescription || "",
    categories: formData.categories.length > 0 ? formData.categories : ["OTHERS"],
    difficultyLevel: formData.difficultyLevel || undefined,
    recommendedAudience: formData.targetAudience,
    associatedToolIds: formData.toolsUsed.length > 0 ? formData.toolsUsed : ["atn::aiforme/tool/unknown"],
    prerequisites: formData.prerequisites.filter(Boolean),
    impact: {
      before: formData.beforeWorkflow || "",
      after: formData.afterWorkflow || "",
      keyImprovements: [
        ...formData.impactIndicators.filter((i) => i !== "OTHER"),
        ...(formData.otherImpactIndicator ? [formData.otherImpactIndicator] : []),
      ],
    },
    steps:
      formData.steps.filter((s) => s.title.trim()).length > 0
        ? formData.steps
            .filter((s) => s.title.trim())
            .map((s, i) => ({
              order: i + 1,
              title: s.title,
              ...(s.expectedResult && { expectedResult: s.expectedResult }),
              ...(s.codeSnippet && { codeSnippet: s.codeSnippet }),
              ...(s.prompt && { prompt: s.prompt }),
              ...(s.learning && { learning: s.learning }),
            }))
        : [{ order: 1, title: "Step 1" }],
    learnMoreLinks: formData.learnMoreLinks
      .filter((l) => l.url.trim())
      .map((l) => ({ title: l.title || l.url, url: l.url })),
    contributorAlias,
    contributorFullName,
    status,
  };
}
